import { Flex, useBreakpointValue } from '@chakra-ui/react'
import { useExperienceManager, useTreatmentPlan } from '@hooks'
import { CopyNoteIcon, TrashIcon } from '@icons'
import React from 'react'
import { Button } from '../Button'
import { PencilIcon } from '../Icon'
import Toolbar from '../Toolbar'

const Actions: React.FC = () => {
  const { onCopyAll, setIsEditing, openDeleteConfirmationModal } =
    useTreatmentPlan()

  const { isExtension } = useExperienceManager()
  const isMobile = useBreakpointValue({ base: true, md: false }) ?? false
  const showButtonText = !isMobile && !isExtension

  return (
    <Toolbar>
      <Flex
        py={4}
        px={2}
        bg="white"
        justifyContent="flex-end"
        {...(!showButtonText && { width: '100%' })}
        gap="8px"
      >
        <Button
          variant="outline"
          onClick={() => setIsEditing(true)}
          leftIcon={showButtonText ? <PencilIcon /> : undefined}
          data-click-text="Edit"
          {...(!showButtonText && {
            w: '48px',
            h: '48px',
            minWidth: '48px',
            maxWidth: '48px',
            p: '0',
            borderRadius: '24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          })}
        >
          {showButtonText ? 'Edit' : <PencilIcon />}
        </Button>
        <Button
          variant="outline"
          onClick={openDeleteConfirmationModal}
          leftIcon={showButtonText ? <TrashIcon fill="#EB5164" /> : undefined}
          data-click-text="Delete"
          {...(!showButtonText && {
            w: '48px',
            h: '48px',
            minWidth: '48px',
            maxWidth: '48px',
            p: '0',
            borderRadius: '24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          })}
        >
          {showButtonText ? 'Delete' : <TrashIcon fill="#EB5164" />}
        </Button>
        <Button
          colorScheme="primary"
          onClick={onCopyAll}
          data-click-text="Copy All"
          {...(!showButtonText && {
            flex: '1',
            minWidth: 'auto',
            w: '100%'
          })}
        >
          Copy All
        </Button>
      </Flex>
    </Toolbar>
  )
}

export default Actions
